// extracted by mini-css-extract-plugin
module.exports = {"NewPasswordForm":"NewPasswordForm_NewPasswordForm__2FrGr","input":"NewPasswordForm_input__1-DfG","rules":"NewPasswordForm_rules__TMBYw"};